import { Component } from 'react';
import _ from 'lodash';
import styles, { Col, Container, ContainerTag, Inner, Logo, Name, RibbonDeleted, Row, Text } from './styles';
import AxlTags from '../AxlTags';
import TimeWithTimezone from 'components/TimeWithTimezone';
import { TIME_ONLY_FORMAT } from 'constants/date';
import { Box } from '@mui/material';

class JMiniStopBox extends Component {
  render() {
    const { stop } = this.props;
    const { shipment: rawShipment, label, client, _deleted } = this.props.stop;
    const shipment = rawShipment || {};
    const driverLabel = label ? label.driver_label : '-';
    const street = rawShipment ? shipment.dropoff_address?.street : '-';
    const customerName = rawShipment ? shipment.customer?.name : '';
    const city = rawShipment ? (shipment.dropoff_address?.city || '') + ', ' + (shipment.dropoff_address?.state || '') + ' ' + (shipment.dropoff_address?.zipcode || '') : '';
    const deletedStyle =
      _deleted || stop.status === 'DISCARDED'
        ? {
            borderTop: '1px solid #d8313280',
            borderBottom: '1px solid #d8313280',
            borderLeft: '1px solid #d8313280',
            borderColor: '#d8313280',
            boxShadow: 'none',
          }
        : {};
    let deletedContent = null;
    if (_deleted) {
      deletedContent = 'DELETED';
    } else if (stop.status === 'DISCARDED') {
      deletedContent = 'DISCARDED';
    } else if (shipment?.inbound_status) {
      switch (shipment.inbound_status) {
        case 'MISSING':
          deletedContent = 'MISSING';
          break;
        case 'RECEIVED_DAMAGED':
          deletedContent = 'DAMAGED';
          break;
        case 'DUPLICATED':
          deletedContent = 'DUPLICATED';
          break;
        default:
          break;
      }
    }

    const status = stop.status === 'PENDING' ? (shipment.status === 'PICKUP_SUCCEEDED' ? 'IN_PROGRESS' : 'PENDING') : stop.status;

    return (
      <Container
        onClick={() => this.props.onClick && this.props.onClick()}
        style={{ ...this.props.style, ...styles.statuses[stop.type][status], ...deletedStyle }}
      >
        {deletedContent && <RibbonDeleted>{deletedContent}</RibbonDeleted>}
        <Inner>
          <Logo>{client?.logo_url && <img style={{ width: '100%', height: '100%', objectFit: 'cover' }} src={client.logo_url} />}</Logo>
          <Row>
            <Col style={{ flex: 0.6 }}>
              <Box as="div" style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
                <Text>{driverLabel}</Text>
                {stop.estimated_arrival_ts && (
                  <TimeWithTimezone
                    variant="tooltip"
                    textFormat={TIME_ONLY_FORMAT}
                    timeTs={stop.estimated_arrival_ts}
                    timezone={shipment.timezone}
                    renderTooltip={(localTime) => `ETA: ${localTime?.text} ${localTime?.zone}`}
                  />
                )}
              </Box>
              <div>
                <Name>{customerName}</Name>
              </div>
            </Col>
            <Col style={{ flex: 0.4 }}>
              <div>
                <Text className={'text-right'}>{street}</Text>
              </div>
              <div>
                <Text className={'text-right'}>{city}</Text>
              </div>
            </Col>
          </Row>
        </Inner>
        {this.props.tags && this.props.tags.length > 0 && (
          <ContainerTag>
            <AxlTags isShowLabel={this.props.isShowLabelTag} tags={this.props.tags} />
          </ContainerTag>
        )}
      </Container>
    );
  }
}

export default JMiniStopBox;
